// extracted by mini-css-extract-plugin
export default {"NotesInput":"Container_NotesInput__U0VNR","Input":"Container_Input__fJAYl"};